import { Content } from '@radix-ui/react-context-menu'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { cn } from '#src/cn.ts'
import { ContextMenuPortal } from '#src/components/ContextMenu/ContextMenuPortal.tsx'

type ContentProps = ComponentPropsWithoutRef<typeof Content>

export interface ContextMenuContentProps extends ContentProps {
  asChild?: boolean
  loop?: boolean
  onCloseAutoFocus?: ContentProps['onCloseAutoFocus']
  onEscapeKeyDown?: ContentProps['onEscapeKeyDown']
  onPointerDownOutside?: ContentProps['onPointerDownOutside']
  onFocusOutside?: ContentProps['onFocusOutside']
  onInteractOutside?: ContentProps['onInteractOutside']
  forceMount?: true
  alignOffset?: number
  avoidCollisions?: boolean
  collisionBoundary?: Element | null | (Element | null)[]
  collisionPadding?: ContentProps['collisionPadding']
  sticky?: 'partial' | 'always'
  hideWhenDetached?: boolean
  /**
   * [data-state] - "open" | "closed"
   * [data-side] - "left" | "right" | "bottom" | "top"
   * [data-align] - "start" | "center" | "end"
   */
  className?: string
}

export const ContextMenuContent = forwardRef<
  ElementRef<typeof Content>,
  ContextMenuContentProps
>(({ className, ...delegated }, ref) => (
  <ContextMenuPortal>
    <Content
      ref={ref}
      className={cn(
        'fade-in-80 data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-32 animate-in overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=closed]:animate-out data-[state=open]:animate-in',
        className
      )}
      {...delegated}
    />
  </ContextMenuPortal>
))
ContextMenuContent.displayName = Content.displayName
